import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/service-categories')({
  staticData: { breadcrumb: 'Категории услуг' },
  component: () => <Outlet />,
});
